<template>
  <div class="templateDetail">
    <div class="bread">
      <el-button
        size="mini"
        plain
        type="primary"
        @click="$router.go(-1)"
      >
        <i class="el-icon-arrow-left" />返回
      </el-button>
      <span style="margin-left:12px;">
        <span
          class="breadHead"
        >网页管理</span>
        <span style="margin:0 9px;color:#C0C4CC;font-weight:700;">/</span>模板管理
      </span>
    </div>
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size:16px;font-weight:700">模板管理</span>
      </div>
    </div>
    <div
      class="layout-cont-box"
    >
      <the-condition
        multiple="identity"
        :limit="selectResult"
        @limit-change="init(1)"
      />
    </div>
    <div
      class="listHead"
      style="margin-top: 12px;"
    >
      <div>
        <div class="sCircle" />
        <span style="font-size:16px;font-weight:700;color: #A0A0A0;">网页模板列表</span>
      </div>
    </div>
    <div style="padding:16px 24px;background-color:#fff;">
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        border
        :header-cell-style="headCss"
        style="width:100%;"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="templateNo"
          label="模板编码"
          align="center"
          min-width="80"
        />
        <el-table-column
          label="模板缩列图"
          width="100"
        >
          <template slot-scope="{row}">
            <div
              class="templateImg"
              @click="openImgDialog(row)"
            >
              <img
                :src="row.thumbnail"
                alt=""
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="模板名称"
          align="center"
          min-width="80"
        />
        <el-table-column
          label="模板类型"
          align="center"
          min-width="80"
        >
          <template slot-scope="{row}">
            <span>{{ row.type === 1 ? 'H5' : 'web' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          align="center"
          min-width="60"
        >
          <template slot-scope="{row}">
            <span>{{ row.status === 1 ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <div class="cell-hand">
              <mix-tooltip
                v-if="scope.row.status === 0"
                :enterable="false"
                content="启用"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <span
                  class="tab-handler tab-able"
                  @click="changeStatus(scope.row)"
                />
              </mix-tooltip>
              <mix-tooltip
                v-else
                :enterable="false"
                content="禁用"
                popper-class="user-table-tooltip weight islocked"
                placement="top"
                effect="light"
              >
                <span
                  class="tab-handler tab-disable"
                  @click="changeStatus(scope.row)"
                />
              </mix-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        style="width:100%;text-align:center;color:#aaa;"
      >
        <img src="../../../../assets/image/no_data.png">
      </div>
    </div>
    <el-dialog
      class="column-dia"
      :visible.sync="showImgDialog"
      :append-to-body="true"
      width="700px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>模板图片</span>
      </div>
      <div
        class="min-scrollbar"
      >
        <img
          :src="imgUrl"
          alt=""
        >
      </div>
    </el-dialog>
    <!-- 这期不显示分页 -->
    <el-pagination
      v-show="pagination.total > 0 && 1 === 2"
      background
      :page-sizes="pageSizes"
      :page-size.sync="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="pagination.current"
      :total="pagination.total"
      @current-change="init"
      @size-change="sizeChange"
    />
  </div>
</template>

<script>
import api from '../proxy';
import TheCondition from '../../../common/TheCondition';
import { pageSizes } from '@/lib/utils';
export default {
    name: 'TemplateDetail',
    components: { TheCondition },
    data () {
        return {
            headCss: { 'background-color': '#F1FFFA' }, // 表头样式
            tableData: [],
            searchInput: '',
            selectResult: {
                templateType: '', // 模板类型
                templateActive: '', // 模板状态
            },
            showDia: false,
            pagination: {
                total: 1,
                current: 1,
                size: 10,
            },
            imgUrl: '',
            pageSizes,
            showImgDialog: false,
        };
    },
    computed: {
        cp_orgId () {
            return this.$store.getters['global/currentOrg'].orgId;
        },
    },
    watch: {
    },
    created: function () {
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init (data) {
            let params = {
                type: this.selectResult.templateType,
                status: this.selectResult.templateActive,
                pageNo: 1,
                pageSize: 999,
            };
            api.getTplList(params).then((res) => {
                if (res.errcode === 0) {
                    this.tableData = res.data.records;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        regEmoji (text) {
            let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
            return text.replace(regStr, '');
        },
        // 启用/禁用
        changeStatus (data) {
            this.$confirm(data.status == 0 ? '启用模板后，新增站点时该模板将可进行正常使用，确认启用？' : '禁用模板后，新增站点时将无法再使用该模板(使用中的模板不受影响)。确认禁用？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                if (data.status == 0) {
                    this.goAble(data.id);
                } else {
                    this.goDisable(data.id);
                }
            }).catch(() => {
            });
        },
        goAble (val) { // 启用
            let params = {
                id: val,
                status: 1,
            };
            api.updateValid(params).then((res) => {
                if (res.errcode === 0) {
                    this.init();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        goDisable (val) { // 禁用
            let params = {
                id: val,
                status: 0,
            };
            api.updateValid(params).then((res) => {
                if (res.errcode === 0) {
                    this.init();
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        openImgDialog (img) {
            this.showImgDialog = true;
            this.imgUrl = img.cover;
        },
        sizeChange (p) {
            this.pagination.size = p;
            this.init();
        },
        onSubmit () {
            console.log(1);
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../../sass/theme.scss";
</style>
<style lang="scss" scoped>
.templateImg{
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    max-width: 100%;
    max-height: 100%;
  }
}
.min-scrollbar{
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
